export const filterIds = (array = [], findId) => array.filter(({ id }) => id.replaceAll('_designer', '') === (findId || `${findId}_designer`));
